import moment from 'moment';
import { createColumnHelper } from '@tanstack/react-table';
import { IEURColumns } from '../utils/types';
import { IconButton } from '@mui/material';
import { PhotoLibrary } from '@mui/icons-material';

const EURReportsColumns = (onPreview: (images: (string | File)[]) => void) => {
  const columnHelper = createColumnHelper<IEURColumns>();

  const EURReportsColumns = [
    columnHelper.accessor('date', {
      id: 'date',
      header: 'Date',
      cell: (row) => moment(row.getValue()).format('MM/DD/yyyy'),
      enableGlobalFilter: true,
      enableColumnFilter: false,
      enableHiding: true
    }),
    columnHelper.accessor('eurNo', {
      id: 'eurNo',
      header: 'EUR No.',
      cell: (row) => row.getValue(),
      enableGlobalFilter: true,
      enableColumnFilter: true,
      enableHiding: true
    }),
    columnHelper.accessor('equipmentNo', {
      id: 'equipmentNo',
      header: 'Equipment No.',
      cell: (row) => row.getValue(),
      enableGlobalFilter: true,
      enableColumnFilter: false,
      enableHiding: true
    }),
    columnHelper.accessor('operator', {
      id: 'operator',
      header: 'Operator',
      cell: (row) => row.getValue(),
      enableGlobalFilter: true,
      enableColumnFilter: false,
      enableHiding: true
    }),
    columnHelper.accessor('location', {
      id: 'location',
      header: 'Location',
      cell: (row) => row.getValue(),
      enableGlobalFilter: true,
      enableColumnFilter: false,
      enableHiding: true
    }),
    columnHelper.accessor('startingReading', {
      id: 'startingReading',
      header: 'Starting SMR',
      cell: (row) => row.getValue(),
      enableGlobalFilter: true,
      enableColumnFilter: false,
      enableHiding: true
    }),
    columnHelper.accessor('endingReading', {
      id: 'endingReading',
      header: 'Ending SMR',
      cell: (row) => row.getValue(),
      enableGlobalFilter: true,
      enableColumnFilter: false,
      enableHiding: true
    }),
    columnHelper.accessor('startingSmrImage', {
      id: 'startingSmrImage',
      header: 'Images',
      cell: ({ row }) => {
        const images: string[] = [];

        if (row.original?.startingSmrImage) images.push(row.original.startingSmrImage as string);
        if (row.original?.endingSmrImage) images.push(row.original.endingSmrImage as string);

        if (!images.length) return "";

        return (
          <IconButton
            color="primary"
            onClick={() => onPreview(images)}
          >
            <PhotoLibrary fontSize="medium" />
          </IconButton>
        );
      },
      enableGlobalFilter: true,
      enableColumnFilter: false,
      enableHiding: true
    })
  ];

  return EURReportsColumns;
}

export default EURReportsColumns;